export function Logo({ size = "md", className = "" }) {
  const sizes = { sm: "text-sm", md: "text-lg md:text-xl", lg: "text-2xl md:text-3xl", xl: "text-4xl md:text-5xl" };
  return (
    <span data-testid="brand-logo" className={`font-heading ${sizes[size]} text-cocoa ${className}`}>
      Sugar<span className="italic font-medium text-mauve">Sense</span>
    </span>
  );
}
